/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { EMapTypeId } from '../../../core/models';

@Component({
  selector: 'fm-map-type-switcher',
  templateUrl: './map-type-switcher.component.html',
  styleUrls: ['./map-type-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapTypeSwitcherComponent {
  @Input() public mapType: EMapTypeId;
  @Output() public switchMapType: EventEmitter<EMapTypeId> = new EventEmitter();

  public EMapType = EMapTypeId;

  public switchMapTypeClick(mapType: EMapTypeId): void {
    this.switchMapType.emit(mapType);
  }
}
